import React from 'react';
import { NavLink } from 'react-router-dom';
import useBreadcrumbs from 'use-react-router-breadcrumbs';
import { useTranslation } from 'react-i18next';
import { usePlatform } from 'hooks';
import { UiIcon } from 'ui-components';
import { routes } from './routes';
import { StyledBreadcrumbs } from './Breadcrumbs.styles';

const excludePaths = [
  '/',
  '/bulletins/smart/:id/:title',
  '/comparisons/source/:id/:platform',
  '/unauthorized',
  'academy/:courseId',
  '/contents/:platform',
  '/resources/:platform',
  '/statistics/:platform',
  '/ecommerce/:platform',
];

export function Breadcrumbs() {
  const breadcrumbs = useBreadcrumbs(routes, {
    excludePaths,
  });
  const { t } = useTranslation();
  const { getDefaultPlatform } = usePlatform();

  const customLink = (link, feature) => {
    if (!link) return undefined;
    return link.replace(':platformId', getDefaultPlatform(feature));
  };

  if (breadcrumbs.length <= 1) {
    return null;
  }

  const filteredBreadcrumbs = breadcrumbs.filter(
    ({ isVisible = true }) => isVisible
  );

  return (
    <StyledBreadcrumbs>
      {filteredBreadcrumbs.map(
        (
          {
            breadcrumb,
            match,
            location,
            link,
            feature,
            shouldTranslate = true,
            translateKey = '',
            shouldBehaveAsLast = false,
          },
          index
        ) => {
          const pathnames = match.pathname.split('/').filter((p) => p);
          const last = index === filteredBreadcrumbs.length - 1;
          const to = last || shouldBehaveAsLast ? location : match.pathname;
          return (
            <>
              <NavLink
                key={match.pathname}
                to={customLink(link, feature) || to}
                end
                className={({ isActive }) =>
                  isActive || shouldBehaveAsLast ? 'active' : ''
                }
              >
                {shouldTranslate
                  ? t(`breadcrumbs:${translateKey || pathnames[index]}`)
                  : breadcrumb}
              </NavLink>
              {index !== filteredBreadcrumbs.length - 1 && (
                <UiIcon
                  icon='ri-arrow-left-s-line'
                  size={20}
                  color='#9CAEBB'
                  hover='#9CAEBB'
                />
              )}
            </>
          );
        }
      )}
    </StyledBreadcrumbs>
  );
}
